import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getWeddingFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `Are food ${vehicleType}s a good option for wedding catering?`,
    answer: `Yes, especially for outdoor weddings, venues without a kitchen, cocktail-style receptions, and late-night snacks. Guests order what they want, the food is made to order, and you skip the full catering setup.`
  },
  {
    question: `How much does food ${vehicleType} wedding catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `How many food ${vehicleType}s do I need for my wedding?`,
    answer: `It depends on guest count, service style, and how long you want the meal to run. Ask each ${vehicleType} how many guests it can serve per hour. For a larger wedding or a tight timeline, couples often book a second ${vehicleType}, or pair a main ${vehicleType} with a dessert or late-night one.`
  },
  {
    question: `Can food ${vehicleType}s accommodate dietary restrictions at weddings?`,
    answer: `Many offer vegetarian, vegan, gluten-free, and allergy-friendly options. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `When should I book a food ${vehicleType} for my wedding?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  },
  {
    question: `Can food ${vehicleType}s serve at my wedding venue in ${cityName}?`,
    answer: `Most can serve at farms, vineyards, private homes, parks, rooftops, and industrial spaces. Venues sometimes have rules about access, power, or parking, so check with yours and share the answers with the ${vehicleType}s you're considering.`
  }
];

function WeddingFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getWeddingFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default WeddingFaq;
